package com.eladfinish.bible.contest.screens.names.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ic_copy
import com.eladfinish.bible.contest.ic_magnify_search
import com.eladfinish.bible.contest.screens.names.data.NameReference
import com.eladfinish.bible.contest.ui.components.buttons.ResourceIcon

@Composable
fun NameItemUi(
    modifier: Modifier = Modifier,
    backgroundAlpha: Float = 0.4f,
    index: Int,
    letter: Char,
    name: String,
    description: String,
    nameReferenceList: List<NameReference>,
    onItemBrowse: (String, List<NameReference>) -> Unit,
    onItemCopy: (String) -> Unit,
    linkifyText: @Composable (
        letter: Char,
        name: String,
        text: String,
    ) -> Unit,
) {
    val nameWithNumber = "($index) $name"
    Card(
        modifier = modifier
            .fillMaxWidth()
            .height(IntrinsicSize.Min)
            .padding(horizontal = 8.dp, vertical = 4.dp),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = Color.White.copy(alpha = backgroundAlpha)),
        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.1f)),
        elevation = CardDefaults.cardElevation(),
    ) {
        Column(
            modifier = Modifier
                .background(Color.Transparent),
            horizontalAlignment = Alignment.Start,
        ) {
            Row {
                SelectionContainer {
                    Text(
                        text = nameWithNumber,
                        modifier = Modifier.padding(vertical = 4.dp, horizontal = 5.dp),
                        textAlign = TextAlign.Start,
                        color = Color.Black,
                        style = MaterialTheme.typography.bodyLarge.copy(
                            fontSize = 17.sp,
                            fontWeight = FontWeight.Bold,
                            textDirection = TextDirection.ContentOrRtl,
                        )
                    )
                }
                Spacer(modifier = Modifier.weight(1f))
                ResourceIcon(
                    modifier = Modifier
                        .padding(4.dp)
                        .clickable {
                            onItemBrowse.invoke(name, nameReferenceList)
                        },
                    imageResource = SharedRes.images.ic_magnify_search,
                    tint = Color.Black
                )
                Spacer(modifier = Modifier.width(4.dp))
                ResourceIcon(
                    modifier = Modifier
                        .padding(4.dp)
                        .clickable {
                            onItemCopy.invoke(nameWithNumber + "\n" + description)
                        },
                    imageResource = SharedRes.images.ic_copy,
                    tint = Color.Black
                )
            }
            Spacer(modifier = Modifier.height(1.dp))

            linkifyText.invoke(letter, name, description)
        }
    }
}
